import "./Stats.css";

const Stats = () => {
    return (<div className="stats-main" >

        <div className="stats-sub" >

            <div className="ss-1">
                <i style={{ backgroundColor: "#E74931" }} class="fa-solid fa-user"></i>
                <h4>11+</h4>
            </div>
            <div className="ss-2">
                <p>Years of experience</p>
            </div>

        </div>

        <div className="stats-sub" >

            <div className="ss-1">
                <i style={{ backgroundColor: "#F6BF22" }} class="fa-solid fa-book-open"></i>
                <h4>30+</h4>
            </div>
            <div className="ss-2">
                <p>Professionally equipped educators</p>
            </div>

        </div>
        <div className="stats-sub" >

            <div className="ss-1">
                <i style={{ backgroundColor: "#6FC70C" }} class="fa-solid fa-puzzle-piece"></i>
                <h4>1000+</h4>
            </div>
            <div className="ss-2">
                <p>Happy young learners</p>
            </div>

        </div>

    </div>)
}

export default Stats;